import AppRouter from "./router/AppRouter";


function App() {
  return (
    <div className="bg-light app">
      <AppRouter/>
    </div>
  );
}

export default App;
